module.exports = __webpack_public_path__ + "media/images/flags/64/Botswana-7bc649e0f42eb8bcd0aef2fb2cd7ef5a.png";